var React = require('react');

function OptionsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 17c.828 0 1.5.672 1.5 1.5S12.828 20 12 20s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm0-6.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zM12 4c.828 0 1.5.672 1.5 1.5S12.828 7 12 7s-1.5-.672-1.5-1.5S11.172 4 12 4z"}));
}

OptionsInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = OptionsInline;

OptionsInline.default = OptionsInline;
